import { Component } from '@angular/core';

@Component({
  selector: 'app-angular',
  templateUrl: 'ApplicationComponent.html'
})
export class ApplicationComponent {
}
